/**
 * Shared user-facing messages for the entitlements admin pages. Kept apart from
 * entitlementsAdminApi so tests that mock that module still get the real text.
 */

/** "403: detail" for an EntitlementsApiError (FastAPI `detail` kept), else the message. */
export const formatEntitlementsError = (err: unknown): string => {
  const e = err as { status?: unknown; detail?: unknown } | null;
  if (e && typeof e.status === "number" && typeof e.detail === "string") {
    return `${e.status}: ${e.detail}`;
  }
  if (err instanceof Error) return err.message;
  return "An unexpected error occurred.";
};

/** A missing or non-numeric count (NaN, undefined) reads as 0. */
export const cacheClearedMessage = (n: number | null | undefined): string => {
  const count = typeof n === "number" && Number.isFinite(n) ? n : 0;
  return `Cleared ${count} cached ${count === 1 ? "entry" : "entries"}. The next page load reads fresh from the database.`;
};
